import { apiRequest, apiRequestRaw, apiRequestWithChecks } from "./api";


export const parishSoft = {
    getFamilyList: function (token, search, pageNum, pageSize, skipTotal) {
        return apiRequestWithChecks("GET", "/api/parishsoft/getFamilies?&search=" + encodeURIComponent(search) + "&pageNum=" + pageNum + "&pageSize=" + pageSize + "&skipTotal=" + skipTotal, {
            "Authorization": "Bearer " + token
        }, undefined, true, false);
    },
    getMemberList: function (token, search, pageNum, pageSize, skipTotal) {
        return apiRequestWithChecks("GET", "/api/parishsoft/getMembers?&search=" + encodeURIComponent(search) + "&pageNum=" + pageNum + "&pageSize=" + pageSize + "&skipTotal=" + skipTotal, {
            "Authorization": "Bearer " + token
        }, undefined, true, false);
    },
    getFamilyWorkgroupList: function (token, pageNumber) {
        return apiRequestWithChecks("GET", "/api/parishsoft/getFamilyWorkgroups?pageNumber=" + pageNumber, {
            "Authorization": "Bearer " + token
        }, undefined, true, false);
    },
    getMemberWorkgroupLookup: function (token, pageNumber) {
        return apiRequestWithChecks("GET", "/api/parishsoft/getMemberWorkgroups?pageNumber=" + pageNumber, {
            "Authorization": "Bearer " + token
        }, undefined, true, false);
    },
    messageList: function (payload) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "POST",
            "/api/parishsoft/ParishSoftMessageList",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            payload,
            true,
            false
        );
    },

    textToSpeech: function (token, message) {
        if (!message || !message.trim()) {
            return Promise.resolve({
                success: false,
                errorMessage: "A message is required."
            });
        }

        return apiRequestWithChecks("POST", "/api/parishsoft/parishsoft-text-to-speech", {
            "Authorization": "Bearer " + token
        }, { message: message }, true, false);
    },

    // Starts a communication session and returns iframeUrl/token
    // No authorization required per spec
    startCommunication: function (payload) {
        return apiRequestWithChecks(
            "POST",
            "/api/parishsoft/communication/start",
            null,
            payload,
            true,
            false
        );
    },

    uploadRecording: function (token, audioBlob, mimeType) {
        return apiRequestRaw("POST", "/api/parishsoft/embedRecording?mimeType=" + encodeURIComponent(mimeType), {
            "Authorization": "Bearer " + token
        }, audioBlob);
    },

    saveAlert: function (token, model) {
        return apiRequestWithChecks("POST", "/api/parishsoft/SaveAlertForParishSoft", {
            "Authorization": "Bearer " + token
        }, model, true, false);
    },
    // Bulk delete alerts/messages (ParishSoft controller)
    bulkDelete: function (payload) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "DELETE",
            "/api/parishsoft/bulk-delete",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            payload,
            false,
            false
        );
    },
    getNotificationList: function () {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "GET",
            "/api/parishsoft/app-notification-list",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            undefined,
            true,
            false
        );
    },
    getNotificationUnreadCount: function () {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "GET",
            "/api/parishsoft/app-unread-count",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            undefined,
            true,
            false
        );
    },
    markNotificationAsRead: function (id) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "PUT",
            "/api/parishsoft/" + encodeURIComponent(id) + "/app-mark-as-read",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            undefined,
            true,
            false
        );
    },
    markAllNotificationsAsRead: function () {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "PUT",
            "/api/parishsoft/app-read-all",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            undefined,
            true,
            false
        );
    },
    getAlertDetails: function (alertId) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "GET",
            "/api/parishsoft/AlertDetails?id=" + alertId,
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            undefined,
            true,
            false
        );
    },
    messagePreview: function (alertId) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "GET",
            "/api/parishsoft/MessagePreview?id=" + alertId,
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            undefined,
            true,
            false
        );
    },

    saveFamilyMemberDetails: function (recipientPayload) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        const body = {
            Recipients: (recipientPayload || []).map(({ selected, ...item }) => item),
        };

        return apiRequest(
            "POST",
            "/api/parishsoft/SaveFamilyMemberDetails",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            body
        );
    },

    getPendoIdentity: function () {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        // Uses apiRequest (not apiRequestWithChecks) so an analytics failure never
        // shows a toast or logs the embedded user out.
        return apiRequest("GET", "/api/parishsoft/pendo-identity", {
            Authorization: "Bearer " + parishSoftToken,
        });
    },
    getAlertCredit: function () {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "GET",
            "/api/parishsoft/alertCredit",
            { Authorization: "Bearer " + parishSoftToken },
            undefined,
            true,
            false
        );
    },
    getEmailAndSenderNames: function () {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "POST",
            "/api/parishsoft/EmailAndSenderNames",
            {
                Authorization: "Bearer " + parishSoftToken,
            },
            null
        );
    },

    getVoiceRecipients: function (request) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "POST",
            "/api/parishsoft/analytics/voice-recipients",
            { Authorization: "Bearer " + parishSoftToken },
            request,
            true,
            false
        );
    },

    getSmsRecipients: function (request) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "POST",
            "/api/parishsoft/analytics/sms-recipients",
            { Authorization: "Bearer " + parishSoftToken },
            request,
            true,
            false
        );
    },

    getEmailRecipients: function (request) {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        return apiRequestWithChecks(
            "POST",
            "/api/parishsoft/analytics/email-recipients",
            { Authorization: "Bearer " + parishSoftToken },
            request,
            true,
            false
        );
    },
}